import _defineProperty from "/var/www/html/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.every.js";
import "core-js/modules/esnext.iterator.find.js";
import Model from "./Model";
import Permission from "./Permission";
export default class SubscriptionPlan extends Model {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "Id", {
      fieldName: 'id',
      content: null
    });
    _defineProperty(this, "name", {
      fieldName: 'name',
      content: null
    });
    _defineProperty(this, "default", {
      fieldName: 'default',
      content: null
    });
    _defineProperty(this, "normalPrice", {
      fieldName: 'normal_price',
      content: null
    });
    _defineProperty(this, "salePrice", {
      fieldName: 'sale_price',
      content: null
    });
    _defineProperty(this, "permissions", {
      fieldName: 'permissions',
      content: []
    });
  }
  getPermissions() {
    return this.permissions.content;
  }
  isPermitted(permission) {
    return Array.isArray(permission) ? permission.length < 1 || permission.includes('*') || permission.every(p => this.getPermissions().find(up => up.getName() === p)) : !permission || this.getPermissions().find(up => up.getName() === permission);
  }
}